import React from 'react';
import {Route, Redirect} from 'react-router-dom';


const API_TOKEN = process.env.API_TOKEN;


export const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            isAuthenticated() && validToken() ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: `${process.env.PUBLIC_URL}/`,
                        state: { from: props.location }
                    }}
                />
            )
        }
    />
);

const validToken = async (token=null) => {
    if (token == null) {
        token = getLocalToken();
        if (!token) return false;
    }

    const response = await fetch(API_TOKEN, {
        method: 'POST',
        body: {'token': token}
    });

    const content = await response;

    if (!content.ok) return false;
    console.log(content.ok);
    return content;
};

const isAuthenticated = () => {

    return !!getLocalToken();

};

const getLocalToken = () => {
    return localStorage.getItem('token');
};